<template>
  <div>
    <a-spin :spinning="loading">
      <a-tabs v-model="activeKey" @change="ChangeTab">
        <a-tab-pane v-for="item in projectTypeArray" :key="item.value" :tab="item.title">
          <div v-if="projectList.length > 0">
            <router-link
              target="_blank"
              :to="'/personalcenters/infocollectindex?pid=' + item.id"
              v-for="(item, index) in projectList"
              :key="index"
            >
              <div class="project-info">
                <div class="project-date">
                  <div class="date">{{ item.updateTime.substr(8, 2) }}</div>
                  <div class="year">{{ item.updateTime.substr(0, 7) }}</div>
                </div>
                <div class="docutit">
                  <div class="title">
                    {{ item.projectName }}
                    <span :class="cmpState(item) === '进行中' ? 'state' : 'stateover'">
                      {{ cmpState(item) }}
                    </span>
                  </div>
                  <div class="brief" v-html="item.noticeInfo"></div>
                  <div class="author">
                    <span class="dataicon" v-if="item.isExpired == 0">
                      起止日期：{{ item.beginTime.substr(0, 16) }} 到 {{ item.endTime.substr(0, 16) }}
                    </span>
                    <span class="dataicon" v-else>长期有效</span>
                  </div>
                </div>
                <div class="pull-right">
                  <div class="rightinfo">
                    <a-button type="primary" shape="round" class="btn">查看详情</a-button>
                  </div>
                </div>
              </div>
            </router-link>
            <div class="page-div">
              <a-pagination
                show-quick-jumper
                :default-current="1"
                :total="total"
                :current="pageNo"
                :pageSize="pageSize"
                @change="onChange"
              />
            </div>
          </div>
          <div class="apply-container" v-else>
            <h1 style="font-size: 16px; text-align: center">暂无采集数据</h1>
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "信息采集项目列表",
  data: function () {
    return {
      loading: true,
      projectList: [],
      projectTypeArray: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      activeKey: "1",
    };
  },
  created() {
    this.getProjectType();
    // this.getProjectList()
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    ChangeTab(index) {
      this.getProjectList()
    },
    getProjectList() {
      const url = `/biz/infocollect/getProjectList?pageNo=${this.pageNo}&pageSize=${this.pageSize}&pgType=${this.activeKey}`;
      this.axios
        .get(url)
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.total = res.result.total;
            this.projectList = res.result.records;
          } else {
            this.total = 0;
            this.projectList = [];
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProjectType() {
      this.axios.get(`/sys/dict/getDictItems/project_type`).then((res) => {
        this.projectTypeArray = res.result
        if (this.projectTypeArray.length > 0) {
          this.activeKey = this.projectTypeArray[0].value
          // 查询项目
          this.getProjectList()
        }
      });
    },
    cmpState({ isExpired, beginTime, endTime, reviewStatus }) {
      if (isExpired === 1) {
        if (reviewStatus === 1) {
          return "待审核";
        } else if (reviewStatus === 2) {
          return "已完成";
        } else if (reviewStatus === 3) {
          return "待终审";
        } else if (reviewStatus === 4) {
          return "已驳回";
        }
        return "进行中";
      }
      // 将字符串日期转换为Date对象
      const startTime = new Date(beginTime);
      const endingTime = new Date(endTime);
      const currentTime = new Date();

      // 比较时间
      if (currentTime >= startTime && currentTime <= endingTime) {
        if (reviewStatus === 1) {
          return "待审核";
        } else if (reviewStatus === 2) {
          return "已完成";
        } else if (reviewStatus === 3) {
          return "待终审";
        } else if (reviewStatus === 4) {
          return "已驳回";
        }
        return "进行中";
      } else if (currentTime < startTime) {
        return "未开始";
      } else {
        return "已结束";
      }
    },

    cmpReviewState({ reviewStatus }) {
      if (reviewStatus === 1) {
        return "待审核";
      } else if (reviewStatus === 2) {
        return "已完成";
      } else if (reviewStatus === 3) {
        return "待终审";
      } else if (reviewStatus === 4) {
        return "已驳回";
      }
    },
    onChange(index) {
      this.pageNo = index;
      this.loading = true;
      this.getProjectList();
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~styles/varibles.styl';

.project-info {
  background: #f7f9f8;
  padding: 12px;
  margin-bottom: 15px;
  height: 120px;
  display: flex;
  border-radius: 10px;

  &:hover {
    box-shadow: 0px 0px 10px #999;
  }
  .project-date {
    border-right: #cad7d2 1px dashed;
    width: 110px;
    color: #2caf7a;
    font-family: ReductoSSK, tahoma, "microsoft yahei", "PingFang SC",
      "PingFang", "Helvetica Neue", "Microsoft YaHei", Helvetica, Arial,
      sans-serif, "\5FAE\8F6F\96C5\9ED1";
    text-align: center;
    font-size: 16px;
    margin-right: 12px;
    .date {
      padding-top: 5px;
      /*margin-bottom: 10px;*/
      font-size: 45px;
    }
  }
  .docutit {
    flex: 1;
    margin-right: 30px;
    padding-right: 0px;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: #666;
    margin-bottom: 10px;
    span {
      color: #ffffff;
      font-size: 13px;
      height: 23px;
      width: 57px;
      display: inline-block;
      padding-left: 12px;
      margin-left: 8px;
      font-weight: normal !important;
      line-height: 23px;
    }
    .state {
      background: url("../../../assets/images/statebg.png") center top no-repeat;
    }
    .stateover {
      background: url("../../../assets/images/statebg.png") left top no-repeat;
      background-position: 0px -23px;
    }
  }
  .brief {
    max-width: 790px;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 显示3行文本 */
    overflow: hidden;
    margin-bottom: 10px;
    p {
      font-size: 14px !important;
    }
    img {
      display: none;
    }
    /deep/ span {
      font-size: 14px !important;
    }
  }
  .rightinfo {
    margin-top: 29px;
  }
  .author {
    color: #999;
    font-size: 14px;
    margin-top: 20px;
    .dataicon {
      background: url("../../../assets/images/dataicon.png") left no-repeat;
      margin-right: 20px;
      padding-left: 24px;
    }
  }
}
.btn {
  background-color: #2caf7a;
  border: #2caf7a solid 1px;
}
.page-div {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/CollectProjectList.vue